 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		19: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		19: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"2c9f5220263347c43ddfe2781fb66cecd9ebf8f0","2":"f38c162a5c18a26ab0274dc3bf95cebc60b4c2aa","3":"4f5c1e2a98ed648987a33f68864fcfd9c43d5013","4":"7b049ea556d2b74aadc85298833afb3f6af29411","5":"01f27674c24ca9c1ab0000fccd6d863bfecd8166","6":"52918f1623f81e5a2b444c18a7fd652a143fa18d","7":"13599ba7a3552b27af2d7b4747250788b541caea","8":"c8f7fe3b0e41be846d5687592cf2018ff6e22687","9":"9d68f0372a415aedfb74882713713932d5d9a271","10":"framework","11":"210e6083","12":"5bc24bd5e226fedf8b5e3a910b93f69de7cac5b0","13":"84c042bb","14":"8b1fc6a074099045e87da659e63abf8024e5a68d","15":"d823fd1bd586ba44cc97605c3e704828e9f183da","16":"ddc9e94f","17":"f057a831","18":"f9fff01a","22":"component---src-pages-404-js","23":"component---src-pages-contact-js","24":"component---src-pages-deployment-js","25":"component---src-pages-devices-js","26":"component---src-pages-form-successful-js","27":"component---src-pages-index-js","28":"component---src-pages-learn-js","29":"component---src-pages-products-js","30":"component---src-pages-search-js","31":"component---src-pages-styles-buttons-js","32":"component---src-pages-styles-grid-js","33":"component---src-pages-styles-index-js","34":"component---src-pages-styles-typography-js","35":"component---src-pages-workspaces-js","36":"component---src-templates-article-js","37":"component---src-templates-deployment-js","38":"component---src-templates-device-js","39":"component---src-templates-experience-js","40":"component---src-templates-legacy-page-js","41":"component---src-templates-product-category-js","42":"component---src-templates-product-js","43":"component---src-templates-workspace-js","44":"component---src-templates-workspace-sub-categories-js"}[chunkId]||chunkId) + "-" + {"0":"407fe62976dc5310c43e","1":"f68a95fba906a94d9324","2":"8d082a4c5adcd83729c5","3":"f564c8aa3efe66bea79b","4":"630217169f8984b37e72","5":"76abd0e5937f0bb364c5","6":"f697a7433ead97a9cac2","7":"5a3870935dad2a0d653d","8":"831a84675dd854296b94","9":"acf7f75a3a3b6739d77e","10":"4db296430519cbb09eca","11":"5c783efbbd67a6a0b3b9","12":"9891286d32a12dd8b837","13":"51eb2d126e2d9c25a0ee","14":"07cad9728de3dae0904a","15":"b117fbcbf53e0f6c731d","16":"0e5ba044dff9ec7c16d4","17":"cfbb74397393218951c0","18":"c0438e13526f8d2435f5","20":"173cc6adcd960ca00c56","22":"5a3bb2083e3f84787f9a","23":"6f938ec9f1a073c5555c","24":"aa99050b465dd2d47be1","25":"23fdb86aa112c09494ef","26":"b40dc91a076c0b9511eb","27":"1a4c4d2f2f7e62b5ab94","28":"fc8cd37cf9abe8968cc1","29":"1863a0a06908eda77da4","30":"60c9b8692f3931358c71","31":"9a17598378f153018153","32":"19bbd1fd82a2d164d97b","33":"f0b888c31f371a68f2f9","34":"4d77849ec226413230f7","35":"b9880cbff2651ee460e9","36":"6ff5f7dd66659dda6302","37":"2eb147ca9d4c62a7d383","38":"6529c6b5fac40e15a960","39":"c7810c3d7bbe771c1832","40":"f6bbdc2025ad2e4ad595","41":"a434e04ab9f8768d8140","42":"7e184bc6103dffc25c92","43":"5487d017fa198e5ee812","44":"436e476a8b1a3807c409","46":"43720c6d6200844b0101","47":"4abca8a9715fc8617602","48":"976f83075767f7e288e0","49":"f6eca28de6eec8a28267","50":"6f347c25b86c52047f5b","51":"85266fc0ef9ffd65ca03","52":"41f99216a8efc66c8265","53":"7a177964159631a118d0","54":"805d18c48f7c3e3e996a","55":"272cba433844ac865ba4"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"2c9f5220263347c43ddfe2781fb66cecd9ebf8f0","2":"f38c162a5c18a26ab0274dc3bf95cebc60b4c2aa","3":"4f5c1e2a98ed648987a33f68864fcfd9c43d5013","4":"7b049ea556d2b74aadc85298833afb3f6af29411","5":"01f27674c24ca9c1ab0000fccd6d863bfecd8166","6":"52918f1623f81e5a2b444c18a7fd652a143fa18d","7":"13599ba7a3552b27af2d7b4747250788b541caea","8":"c8f7fe3b0e41be846d5687592cf2018ff6e22687","9":"9d68f0372a415aedfb74882713713932d5d9a271","10":"framework","11":"210e6083","12":"5bc24bd5e226fedf8b5e3a910b93f69de7cac5b0","13":"84c042bb","14":"8b1fc6a074099045e87da659e63abf8024e5a68d","15":"d823fd1bd586ba44cc97605c3e704828e9f183da","16":"ddc9e94f","17":"f057a831","18":"f9fff01a","22":"component---src-pages-404-js","23":"component---src-pages-contact-js","24":"component---src-pages-deployment-js","25":"component---src-pages-devices-js","26":"component---src-pages-form-successful-js","27":"component---src-pages-index-js","28":"component---src-pages-learn-js","29":"component---src-pages-products-js","30":"component---src-pages-search-js","31":"component---src-pages-styles-buttons-js","32":"component---src-pages-styles-grid-js","33":"component---src-pages-styles-index-js","34":"component---src-pages-styles-typography-js","35":"component---src-pages-workspaces-js","36":"component---src-templates-article-js","37":"component---src-templates-deployment-js","38":"component---src-templates-device-js","39":"component---src-templates-experience-js","40":"component---src-templates-legacy-page-js","41":"component---src-templates-product-category-js","42":"component---src-templates-product-js","43":"component---src-templates-workspace-js","44":"component---src-templates-workspace-sub-categories-js"}[chunkId]||chunkId) + "." + {"0":"2b4d81c9ff7b312f1610","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
